import { createContext } from 'react';
import { CompositeFieldValue } from '#types/System.types';

/** Context value for composite field editing: id, value, and setters for sub-fields and entity references. */
export interface CompositeFieldContextValue {
  compositeFieldId: string;
  compositeFieldTypeId: string;
  compositeFieldValue: CompositeFieldValue | undefined;
  isFormulaColumn: boolean;
  /**
   * Sub-field IDs the platform computes, mapped to the sentence saying why each
   * is locked. Two sources feed one map: this composite's targets in the table's
   * `formulaSequence`, and the sub-fields a Form Derive projection fills on the
   * row. Neither is the person's to edit, and no control can tell them apart —
   * so the reason travels with the id, or the control is disabled in silence.
   */
  computedSubFieldReasons: ReadonlyMap<string, string>;
  setSubFieldValue: (fieldId: string, value: unknown) => void;
  setEntityReference: (referenceKey: string, data: { entityRecordId: string | undefined; entityRecordName: string }) => void;
}

/** React context providing composite field state and mutation helpers to nested LayoutUI controls. */
export const CompositeFieldContext = createContext<CompositeFieldContextValue | null>(null);
